import { Pipe, PipeTransform } from '@angular/core';
import bigDecimal from 'js-big-decimal';

@Pipe({ name: 'amount' })
export class PipeAmount implements PipeTransform {

    transform(value: bigint): string {
        const number = bigDecimal.divide(value.toString(), '1000000000', 4);
        const integer = number.split('.')[0];
        const decimal = ((number.split('.').length > 1 ? number.split('.')[1] : '') + '0000').slice(0, 2);

        return integer + '.' + decimal;
    }
}